import { render, staticRenderFns } from "./OnboardingAccommodationPhotosPage.vue?vue&type=template&id=cc2f6d1c&scoped=true&"
import script from "./OnboardingAccommodationPhotosPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingAccommodationPhotosPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingAccommodationPhotosPage.vue?vue&type=style&index=0&id=cc2f6d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2f6d1c",
  null
  
)

export default component.exports